// Material Kit 2 React pages

import Investigation from "presentation/components/InvestigationPage";

export default function InvestigationPage() {
  return <Investigation />;
}
